module.exports = "<div class=\"widget-body\">\n\t<div class=\"widget-main\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/widget/widget-body.html
// module id = 544
// module chunks = 0